import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vant/lib/index.css';
import "./networking"
import { Toast ,Overlay ,List ,Swipe, SwipeItem ,Cell ,NoticeBar , Switch, RollingText} from 'vant';
createApp(App)
.use(Toast)
.use(Overlay)
.use(List)
.use(store)
.use(router)
.use(Swipe)
.use(Cell)
.use(NoticeBar)
.use(SwipeItem)
.use(Switch)
.use(RollingText)
.mount('#app')
